import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            libelle: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                libelle: element.libelle.toUpperCase(),
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/grilletarifaires/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setgrilletarifaire(state, grilletarifaires) {
        state.all = grilletarifaires
    },
    addgrilletarifaire(state,grilletarifaire){
        state.all.push(grilletarifaire)
    }
}

const actions={
    async get_all_grilletarifaires({ commit }, serverParams){
        return api.grilletarifaire.get_all_grilletarifaires(serverParams).then((response)=>{
            commit('setgrilletarifaire', response.data.data.data)
            return response.data.data
        })
    },
    post_grilletarifaires({commit},grilletarifaire){
        return api.grilletarifaire.post_grilletarifaires(grilletarifaire).then((response)=>{
            commit('addgrilletarifaire', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_grilletarifaires({ commit }, data) {
        return api.grilletarifaire.put_grilletarifaires(data.libelle, data.grilletarifaire).then((response) => {
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    show_grilletarifaires({ commit }, libelle) {
        return api.grilletarifaire.show_grilletarifaires(libelle).then((response) => {
            return response.data.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
